import styled from 'styled-components'

export const ImageCard = styled.div`
  height: ${props => (props.isHorizontal ? '172px' : '189px')};
  width: ${props => (props.isHorizontal ? '327px' : '249px')};
  display: flex;
  justify-content: flex-end;

  a,
  img {
    max-height: 100%;
    width: 100%;
    object-fit: cover;
    align-self: center;
  }
`
